import React, { useMemo, useState, useEffect, useRef, forwardRef } from "react";
import {
  Tabs,
  Input,
  Typography,
  Select,
  Row,
  Col,
  Button,
  Drawer,
} from "antd";
import { isMobile } from "@/utils/public";
import { SearchOutlined } from "@ant-design/icons";
import { getZskTypes, getZskListData } from "@/api/index";
import Wjj from "../../assets/images/wjj.svg";
import Detail from "./detail";
import useBaseRequest from "@/hooks/useBaseRequest";

function Zskzx(props, ref) {
  const { onClick } = props;
  const isMob = isMobile();
  const [inputValue, setInputValue] = useState("");
  const [activeKey, setActiveKey] = useState("0");
  const detailRef = useRef();
  const { data: initCate, loading: loading2 } = useBaseRequest(getZskTypes, {
    // manual: true,
  });
  const {
    data: initCateList,
    loading,
    runAsync: runSearch,
  } = useBaseRequest(
    () =>
      getZskListData({
        type: activeKey === "0" ? "" : activeKey,
        keyword: inputValue,
      }),
    {
      // manual: true,
      refreshDeps: [activeKey, inputValue],
    },
  );

  if (ref) {
    ref.current = {
      closeModel: () => {
        detailRef.current?.closeModel();
      },
    };
  }

  const Items = useMemo(() => {
    const cateList = [{ name: "全部", code: "0" }, ...(initCate?.data ?? [])];
    // console.log(cateList)
    const cate = cateList?.map((item, index) => {
      return {
        title: item.name,
        key: item.code,
        children:
          activeKey === "0" || activeKey === item.code
            ? initCateList?.data.map((jtem) => {
                // console.log(jtem, "多智能体搜索当中的")
                return {
                  label: jtem.name,
                  icon: Wjj,
                  key: jtem.id + "",
                  sj: jtem.createdAt,
                  user: jtem.createdBy,
                  source: jtem.typeName,
                };
              })
            : [],
      };
    });
    // console.log(cate);
    return cate;
  }, [initCateList, initCate, activeKey]);

  return (
    <div className="zdSearch">
      <div className="mxgcHeader">
        <div
          className="title"
          style={{
            padding: isMob ? "0 24px 0 28px" : "0 35px",
          }}
        >
          {isMob ? "" : "知识库中心"}
        </div>
      </div>
      <div className={`${isMob ? "m-zdSearchContent" : "zdSearchContent"}`}>
        <div className="content">
          {isMob ? (
            <>
              <div className="m-search">
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <Input
                      value={inputValue}
                      onChange={(e) => {
                        // setInputValue(e.target.value)
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          // runSearch(inputValue)
                        }
                      }}
                      suffix={
                        <SearchOutlined
                          style={{ fontSize: 16, color: "#1677ff" }}
                        />
                      }
                      placeholder="搜索模型"
                    />
                  </Col>
                  <Col span={24}>
                    <Button type="primary">搜索</Button>
                  </Col>
                </Row>
              </div>
            </>
          ) : (
            <div className="pcSearch">
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Input
                    value={inputValue}
                    onChange={(e) => {
                      setInputValue(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setInputValue(e.target.value);
                      }
                    }}
                    suffix={
                      <SearchOutlined
                        style={{ fontSize: 16, color: "#1677ff" }}
                      />
                    }
                    placeholder="请输入 "
                  />
                </Col>
                <Col span={12}>
                  <Button
                    type="primary"
                    onClick={() => {
                      window.open("https://kr.zju.edu.cn/anyshare/zh-cn/dir");
                    }}
                  >
                    管理知识库
                  </Button>
                </Col>
              </Row>
            </div>
          )}

          <Tabs
            style={{
              height: isMob ? "calc(100% - 45px)" : "100%",
            }}
            type="card"
            key={"mxgc"}
            items={Items?.map((item, index) => {
              // console.log(item, "tabs的值")
              return {
                label: item?.title,
                key: item.key,
                children: (
                  <Detail
                    ref={detailRef}
                    mobile={isMob}
                    data={item.children}
                    onClick={onClick}
                  />
                ),
              };
            })}
            tabBarGutter={15}
            activeKey={activeKey}
            onChange={(activeKey) => {
              setActiveKey(activeKey);
            }}
            tabBarExtraContent={{
              right: isMob ? undefined : (
                <div
                  style={{
                    width: "300px",
                  }}
                ></div>
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default forwardRef(Zskzx);
